import { PersonalApiKeysSortField } from "components/ApiKeys/PersonalApiKeys/Table/useSort";
import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const USER_PERSONAL_API_KEYS_COLUMNS_STORAGE_KEY = "userPersonalApiKeysColumnsConfig";
export const USER_PERSONAL_API_KEYS_FILTERS_ORDER_KEY = "userPersonalApiKeysFiltersOrder";

export enum USER_PERSONAL_API_KEYS_COLUMN_ID {
  NAME = "NAME",
  ISSUES = "ISSUES",
  KEY_ID = "KEY_ID",
  CREATED_AT = "CREATED_AT",
  EXPIRES_AT = "EXPIRES_AT",
  LAST_USED = "LAST_USED",
  ACTIONS = "ACTIONS",
}

const MAX_CELL_WIDTH = 2000;

const BASE_COLUMN_META = {
  maxWidth: 400,
  resizable: true,
  allowsSorting: true,
  canHide: false,
  canMove: false,
  canPin: false,
};

export const USER_PERSONAL_API_KEYS_COLUMN_CONFIG: Record<
  USER_PERSONAL_API_KEYS_COLUMN_ID,
  TableColumnMeta
> = {
  [USER_PERSONAL_API_KEYS_COLUMN_ID.NAME]: {
    ...BASE_COLUMN_META,
    id: USER_PERSONAL_API_KEYS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 260,
    maxWidth: MAX_CELL_WIDTH,
  },
  [USER_PERSONAL_API_KEYS_COLUMN_ID.ISSUES]: {
    ...BASE_COLUMN_META,
    id: USER_PERSONAL_API_KEYS_COLUMN_ID.ISSUES,
    title: "Issues",
    minWidth: 100,
    defaultWidth: 140,
    allowsSorting: false,
  },
  [USER_PERSONAL_API_KEYS_COLUMN_ID.KEY_ID]: {
    ...BASE_COLUMN_META,
    id: USER_PERSONAL_API_KEYS_COLUMN_ID.KEY_ID,
    title: "Key ID",
    minWidth: 200,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
  },
  [USER_PERSONAL_API_KEYS_COLUMN_ID.CREATED_AT]: {
    ...BASE_COLUMN_META,
    id: USER_PERSONAL_API_KEYS_COLUMN_ID.CREATED_AT,
    title: "Created at",
    minWidth: 120,
    defaultWidth: 160,
  },
  [USER_PERSONAL_API_KEYS_COLUMN_ID.EXPIRES_AT]: {
    ...BASE_COLUMN_META,
    id: USER_PERSONAL_API_KEYS_COLUMN_ID.EXPIRES_AT,
    title: "Expires at",
    minWidth: 120,
    defaultWidth: 160,
  },
  [USER_PERSONAL_API_KEYS_COLUMN_ID.LAST_USED]: {
    ...BASE_COLUMN_META,
    id: USER_PERSONAL_API_KEYS_COLUMN_ID.LAST_USED,
    title: "Last used",
    minWidth: 120,
    defaultWidth: 160,
  },
  [USER_PERSONAL_API_KEYS_COLUMN_ID.ACTIONS]: {
    ...BASE_COLUMN_META,
    id: USER_PERSONAL_API_KEYS_COLUMN_ID.ACTIONS,
    title: "API key actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    resizable: false,
    allowsSorting: false,
    configurable: false,
  },
};

type UserPersonalApiKeysSortKey = keyof Pick<
  typeof USER_PERSONAL_API_KEYS_COLUMN_ID,
  "NAME" | "KEY_ID" | "CREATED_AT" | "EXPIRES_AT" | "LAST_USED"
>;

export const USER_PERSONAL_API_KEYS_SORT_CONFIG: Record<
  UserPersonalApiKeysSortKey,
  PersonalApiKeysSortField
> = {
  [USER_PERSONAL_API_KEYS_COLUMN_ID.NAME]: "name",
  [USER_PERSONAL_API_KEYS_COLUMN_ID.KEY_ID]: "id",
  [USER_PERSONAL_API_KEYS_COLUMN_ID.CREATED_AT]: "createdAt",
  [USER_PERSONAL_API_KEYS_COLUMN_ID.EXPIRES_AT]: "expiresAt",
  [USER_PERSONAL_API_KEYS_COLUMN_ID.LAST_USED]: "lastUsedAt",
};

export const USER_PERSONAL_API_KEYS_SORT_FIELDS = Object.values(USER_PERSONAL_API_KEYS_SORT_CONFIG);

export const USER_PERSONAL_API_KEYS_INITIAL_SORT = {
  field: USER_PERSONAL_API_KEYS_SORT_CONFIG[USER_PERSONAL_API_KEYS_COLUMN_ID.NAME],
  direction: SearchQueryOrderDirection.Asc,
};
